import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { logout } from "../../../features/auth";
import { IRoadMeasures } from "../../../models/storeModels/IRoadMeasures";

function getInitialState() {
    const initialState: IRoadMeasures = {
        currentRoadMeasure: undefined
    };
    return initialState;
}


export const roadMeasuresSlice = createSlice({
    name: 'roadMeasures',
    initialState: getInitialState(),
    reducers: {
        setCurrentRoadMeasure(state, action: PayloadAction<any>) {
            state.currentRoadMeasure = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(logout, () => {
            return getInitialState()
        })
    },
})

export const { setCurrentRoadMeasure } = roadMeasuresSlice.actions
export const roadMeasuresReducer = roadMeasuresSlice.reducer;
